import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Input, Form, FormGroup, Button, Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { changePassword } from "../../api/auth";
import Logo from "../../assets/img/HT-Logo-Wordmark.svg";
import "./login.scss";

const ChangePassword = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [resetKey, setResetKey] = useState("");
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Parse query parameters from URL
    const searchParams = new URLSearchParams(location.search);
    const key = searchParams.get("resetKey");
    const userEmail = searchParams.get("email");

    if (key && userEmail) {
      setResetKey(key);
      setEmail(userEmail);
    } else {
      // If no reset key or email, redirect to login
      toast.error("Invalid password reset link");
      navigate("/login");
    }
  }, [location, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const password = e.target.elements.password1.value;
    const confirmPassword = e.target.elements.password2.value;

    if (!password) {
      toast.error("Password cannot be empty!");
      return;
    }

    if (!confirmPassword) {
      toast.error("Confirm Password cannot be empty!");
      return;
    }

    if (confirmPassword !== password) {
      toast.error("Passwords should be same");
      return;
    }

    setLoading(true);

    try {
      const response = await changePassword({
        username: email,
        password: password,
        activationKey: resetKey,
      });

      if (response?.body) {
        setSuccess(true);
        toast.success(response.body);
        // Navigate to login after successful password change
        setTimeout(() => navigate("/login"), 2000);
      }
    } catch (error) {
      console.error("Change password error:", error);
      toast.error("Failed to change password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginTop: "3rem" }} className="wrapper fadeInDown">
      <div id="formContent">
        <div className="fadeIn first">
          <img src={Logo} id="icon" alt="User Icon" />
        </div>

        <br />

        <Form className="login-container-padding" onSubmit={handleSubmit}>
          <FormGroup>
            <Input
              readOnly={loading}
              type="password"
              id="password1"
              className="fadeIn second"
              name="password1"
              placeholder="New Password"
              autoComplete="new-password"
            />
          </FormGroup>
          <FormGroup>
            <Input
              readOnly={loading}
              type="password"
              id="password2"
              className="fadeIn third"
              name="password2"
              placeholder="Confirm Password"
              autoComplete="new-password"
            />
          </FormGroup>

          <Button
            type="submit"
            className="fadeIn fourth"
            color="primary"
            disabled={loading || success}
          >
            {loading ? <Spinner size="sm" /> : "Change Password"}
          </Button>
        </Form>

        <div id="formFooter">
          <Button
            className="underlineHover"
            onClick={() => navigate("/login")}
            color="link"
          >
            Back to Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
